var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('page-title',{attrs:{"header":"Solicitação de Câmbio","subheader":"Preencha as informações abaixo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","offset-md3":"","md6":"","pt-3":""}},[_c('calculator')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745a8674","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ExchangeRequest.vue
// module id = null
// module chunks = 